exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".join-message {\n  font-size: 17px;\n  font-size: 1.4vw;\n  font-weight: 600;\n  display: flex;\n  align-items: center; }\n  @media (max-width: 1071.42857px) {\n    .join-message {\n      font-size: 15px; } }\n  @media (min-width: 1428.57143px) {\n    .join-message {\n      font-size: 20px; } }\n  .join-message .avatar-container {\n    border-width: 0;\n    margin: 5px; }\n  .join-message .timestamp {\n    color: lightgray;\n    font-size: 14px;\n    font-weight: 100; }\n  .join-message .vertical-items {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    margin-top: -10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/views/messages/modern/genericAction.scss
// module id = 1053
// module chunks = 0